"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgOutgoingCall = function SvgOutgoingCall(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m13.384 1.35.984.879c.743.661.863 1.597.36 2.807-.755 1.815-3.585 6.192-9.75 9.891-1.36.957-2.58.741-3.142 0-.374-.494-.74-.967-1.1-1.42-.4-.616-.231-1.188.504-1.715 1.102-.792.75-.513 1.65-1.13.902-.618.894-.48 2.089 0 1.194.48 1.206.897 2.39-.233.789-.753 1.8-1.783 3.033-3.088.463-.434.463-.977 0-1.627-.694-.974-.694-1.349 0-2.417.463-.712.939-1.361 1.429-1.948.513-.465 1.031-.465 1.553 0zm-10.9 1.8L7.038 7.8m-5.512-2 .718-2.963 3.113-.252",
    fill: "none",
    stroke: "#919499"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgOutgoingCall);
var _default = exports["default"] = Memo;